<template>
  <div class="wrapper">
      <SearchForm></SearchForm>
      <div id="search-header">
        Results for "{{query}}":
      </div>
      <div id="search-list">
          <ul>
              <li v-for="page in items" :key="page.id">
                  <router-link :to="{ name: 'Page', params: { page_id: page.id }}">{{page.name}}</router-link>
              </li>
          </ul>
      </div>
  </div>

</template>

<script>
  import SearchForm from './SearchForm'


export default {
  name: 'Search',
  data() {
    return {
      items: []
    }
  },
  components: {
    SearchForm
  },
  methods: {
    searchItems() {
      axios.get(this.$conf.apiHost+'/api/faq/search?query='+this.query+"&site_id="+this.$conf.siteId).then((response) => {
          this.items = response.data;
      });
    }
  },
  mounted: function() {
    this.searchItems();
  },
  computed: {
    query () {
      return this.$route.params.query;
    }
  },
   watch: {
      'query': function() {
          this.searchItems()
      }
   }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue